import TableHeaderTitleCell from 'app/components/TableHeaderTitleCell';

const QuantityTableHeaderTitleCell = ({ unit, ...rest }) => {
  const subTitle = unit ? `(${unit})` : undefined;

  return <TableHeaderTitleCell subTitle={subTitle} {...rest} />;
};

export default QuantityTableHeaderTitleCell;
